import './Tabs.scss'

import _ from 'lodash'
export default {
    name: 'Tabs',

    data: {
        index: 0,
        navType: null,
        tabs: []
    },

    computed: {
        tabHasCta () {
            return !!(this.tabs[this.index] && this.tabs[this.index].tab_button_text && this.tabs[this.index].tab_button_url && this.tabs[this.index].tab_button_url.url)
        },

        tab () {
            return this.tabs[this.index]
        }
    },

    watch: {
        index (index) {
            if (this.$refs.labels && this.$refs.labels.length) {
                _.each(this.$refs.labels, label => label.classList.remove('tabs__label--active'))
                this.$refs.labels[index].classList.add('tabs__label--active')
            }
        }
    },

    mounted () {
        const id = this.$el.getAttribute('data-component-id')
        const data = id ? window[`_data_${id}`] : null
        const li = this.$el.querySelectorAll('.tabs__top li')

        if (data) {
            // set tabs object to tabs array
            this.tabs = data.tabs
            this.navType = data.navType
        }
    },

    methods: {
        toggleList (e) {
            this.index = Array.prototype.indexOf.call(this.$refs.labels, e.target)
        },

        toggleSelect (e) {
            this.index = parseInt(this.$refs.select.value)
        }
    }
}


// WEBPACK FOOTER //
// ./mtwp/Theme/Components/Tabs/Tabs.js